/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NoPaymentRequiredParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('no-payment-required')],
]);
export class NoPaymentRequired extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NoPaymentRequiredParser.decode(input).map(res => new NoPaymentRequired(res));
    }
    static unsafeDecode(input) {
        return NoPaymentRequired.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NoPaymentRequiredParser.encode(data);
    }
    static schema() {
        return NoPaymentRequiredParser.schema();
    }
}
